<template>
  <div class="page">
    <div :class="'card'+ (index == 0?' card-bg':'')" v-for="(item, index) in items" :key='index'>
      <div>{{item.title}}</div>
      <div>{{item.subTitle}}</div>
      <div :class="'button' + (index == 1?' color':'')"  @click='goOrders(index)'>{{item.buttonText}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OrderCenter',
    data() {
      return {
        items: [
          {
            title: '商品订单',
            subTitle: '正品行货  闪电送达  无忧售后',
            buttonText: '查看商品订单 >',
            url: 'https://m.3ceasyb2b.com/order/list?companyId=2'
          },
          {
            title: '维修订单',
            subTitle: '专业维修  上门服务  价格透明',
            buttonText: '查看维修订单 >',
            url:'https://r.piseneasy.com/wechat/orders'
          }
        ],
      };
    },
    methods: {
      goOrders(index) {
        this.goto(this.items[index].url)
      },
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page {
    color: white;
    overflow: hidden;
    min-height: 100vh;
  }

  .card {
    margin: 0 3vw;
    height: calc((100vw - 3vw*2)/1.85);
    border-radius: 8px;
    background-image: url('../../assets/order_sale.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
    padding: 0 16px;
  }

  .card-bg {
    background-image: url('../../assets/order_service.png');
  }

  .page .card:first-child {
    margin-top: 32px;
  }

  .card+.card {
    margin-top: 20px;
  }

  .card div:nth-child(1) {
    padding-top: 8.26vw;
    font-size: 18px;
  }

  .card div:nth-child(2) {
    padding-top: 4.26vw;
    font-size: 12px;
  }

  .button {
    height: 24px;
    line-height: 24px;
    display: inline-block;
    margin-top: 10.4vw;
    font-size: 10px;
    border-radius: 12px;
    padding: 0 10px;
    background-color: #049B9A;
  }

  .button:active {
    filter: opacity(0.6);
  }

  .color {
    background-color: #E4A73E;
  }
</style>